module.exports = __webpack_public_path__ + "img/MAC1630_1-1.a4aaca15.jpg";